import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";

import CustomText from "../../../Components/Text";
import MasKInput from "../../../Components/IconInputField";
import { STYLES } from "../../../Constant/Theme";
import { TextLink } from "../styles";
import Colors from "../../../Constant/Colors";
import IconButton from "../../../Components/IconButton";
import images from "../../../Constant/images";
import { useDispatch, useSelector } from "react-redux";
import { apiLoginRequest } from "../../../Redux/actions/auth";


const LoginForm = ({ auth, handleAuthPage, }) => {
  const dispatch = useDispatch()
  const [signupErrors] = useState("");
  const [showPass, setShowPass] = useState(false);
  const initialValues = {
    password: "",
    email: "",
    isChecked: false
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Please enter email address"),
    password: yup
      .string()
      .required("Please enter password"),

  });

  const onSubmit = (values) => {
    let data = values;
    // console.log("data", data);
    dispatch(apiLoginRequest(data))

    // dispatch(apiSignupRequest(values));
  };
  const formik = useFormik({ initialValues, validationSchema, onSubmit });

  useEffect(() => {
    if (signupErrors && Object.keys(signupErrors).length) {
      formik.setErrors(signupErrors);
    }
  }, [signupErrors]);
  const styles = {
    main: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'center',
      flexDirection: 'column'
    },
    container: {
      width: "50%",
      minWidth: 220,
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
  }

  

  return (
    <div style={styles.main} >
      <div style={styles.container} >
        <MasKInput
          name="email"
          placeholder="Enter Email Address"
          type={'email'}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          value={formik.values.email}
          icon={images.mail}
          onBlur={formik.handleBlur}
          error={
            formik.touched.email &&
            formik.errors.email &&
            formik.errors.email
          }
        />
        <MasKInput
          name="password"
          placeholder="Enter Password"
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          value={formik.values.password}
          onBlur={formik.handleBlur}
          error={
            formik.touched.password &&
            formik.errors.password &&
            formik.errors.password
          }
          type={showPass ? 'text' : 'password'}
          icon={images.lock}
          rightIcon={images.eye_off}
          rightIconPress={() => setShowPass(!showPass)}
        />
      </div>
      <div style={{ width: "50%", minWidth: 220 }}>
        <div
          style={{
            ...STYLES.HorizontalAlign,
            justifyContent: "space-between",
          }}
        >
          <div style={STYLES.HorizontalAlign}>
            <input
              type="checkbox"
              style={{ width: 15, height: 15, marginRight: 10 }}
              checked={formik.values.isChecked}
              onChange={() =>
                formik.setFieldValue("isChecked", !formik.values.isChecked)
              }
            />
            <CustomText text={"Remember me"} />
          </div>
          <div style={{ cursor: "pointer" }}>
            <TextLink to={"/forget-password"}>Forget Password?</TextLink>
          </div>
        </div>

      </div>
      <div style={{ width: "50%", minWidth: 220 }}>
        <IconButton
          text={"Sign In"}
          onClick={formik.handleSubmit}
          loading={auth?.isLoading}
          disabled={auth?.isLoading}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              formik.handleSubmit();  // Trigger the form submission
            }
          }}
        />

        <p
          className="form-text text-center mt-4"
          style={{ fontSize: 12, color: Colors.primary, textAlign: "center" }}
        >
          Don’t have an account?{"   "}
          <TextLink onClick={() => handleAuthPage("isLogin", false)}>
            Sign Up
          </TextLink>
        </p>
      </div>


    </div>
  );
};
export default LoginForm;
